import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { setArticlesCashCategoyEdit, fetchArticlesCashCategory, updateArticlesCashCategory } from '../../action/handbook';
import cn from 'classnames';
import Loader from '../utils/Loader';
import ErrorContainer from '../utils/ErrorContainer';
import { setUIvisible } from '../../action/UImobile';
import Switch from '../utils/Switch';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class EditArticlesCashCategory extends Component {
    componentWillUnmount() {
        this.props.setArticlesCashCategoyEdit(null);
    }

    componentDidMount() {
        this.props.fetchArticlesCashCategory(this.props.match.params.id).then(article => {
            this.props.setArticlesCashCategoyEdit(article);
        });
        this.props.setUIvisible(false, false);
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">{this.props.edit.name ? this.props.edit.name : 'Введите название категории *'}</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/articlesCashCategories')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValid() {
        const { name } = this.props.edit;
        if (name) return true;
        
        return false;
    }

    setData = (field) => (e) => {
        const data = {...this.props.edit};
        data[field] = e.target.value;
        this.props.setArticlesCashCategoyEdit(data);
    }


    onChangeSwitch = (field) => (e) => {
        const data = {...this.props.edit};
        data[field] = e;

        if (field === 'controlled' && e === true) data.uncontrolled = false;
        if (field === 'uncontrolled' && e === true) data.controlled = false;
        
        this.props.setArticlesCashCategoyEdit(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        const edited = { ...this.props.edit };
        this.props.updateArticlesCashCategory(this.props.match.params.id, edited).then(result => {
            if (result) {
                this.props.history.push('/handbook/articlesCashCategories');
            }
        });        
    }

    render() {
        const { loading, edit } = this.props;
        if (loading || !edit) {
            return (
                <div style={styles.loading}><Loader/></div>
            );
        }

        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <form onSubmit={this.onSubmit} className="kt-form">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-4">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setData('name')}
                                        value={edit.name}
                                        placeholder="Название..."
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="col-12 col-form-label">Контролируемые расходы</label>
                                    <div className="col-12">
                                        <Switch disabled={edit.uncontrolled} onChange={this.onChangeSwitch('controlled')} checked={edit.controlled}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="col-12 col-form-label">Неконтролируемые расходы</label>
                                    <div className="col-12">
                                        <Switch disabled={edit.controlled} onChange={this.onChangeSwitch('uncontrolled')} checked={edit.uncontrolled}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet">
                        <ErrorContainer field="editArticleCashCategory" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValid() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.editArticleCashLoader })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>                    
                    </div>
                </form>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    edit: state.handbook.articlesCashCategory.edit,
    loading: state.loaders.articlesCashCategory,
    editArticleCashLoader: state.loaders.editArticlesCashCategory,
});

const mapDispatchToProps = {
    setArticlesCashCategoyEdit: (data) => setArticlesCashCategoyEdit(data),
    fetchArticlesCashCategory: (id) => fetchArticlesCashCategory(id),
    updateArticlesCashCategory: (id, data) => updateArticlesCashCategory(id, data),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditArticlesCashCategory);